import charts from '../charts.js';

export default function({ id, data, config, dates }) {
	const isFinancialsSection = window.config.url.data[1] == 'financials';

	const settings = {
		data,
		legend: {
			labels: {
				maxWidth: null,
			},
		},
		scrollbar: {
			series: {
				valueYField: 'close',
			},
		},
		yAxis: {
			numberFormat: ( isFinancialsSection && config.unit == '%' ) ? "#'%'" : "#.#a",
		},
	};

	if (isFinancialsSection) {
			const selectedGrouping = config.baseInterval==='yearly' ? charts.groupings.yearly : charts.groupings.daily;

			settings.xAxis = {
				baseInterval: selectedGrouping[0],
				groupIntervals: selectedGrouping,
				groupCount: config.groupCount,
				groupData: true,
			};

			settings.scrollbar=false;//TODO:find a way to fix the scrollbar.
	}

	const chart = charts.draw(id, settings, dates);

	if (isFinancialsSection) {
		chart.setPrefixesForYAxis({
			bigNumberPrefixes: charts.bigNumberPrefixes,
			smallNumberPrefixes: [],
		});
	}

	chart.addSeries(
		chart[ `${config.series_type ?? 'line'}Series` ]({
			legendLabelText: config.title,
			valueYField: 'close',
			stroke: charts.colours.pink,
			fill: config.series_type === 'column' ? charts.colours.pink : null,
		})
	);

	if (config.extra) {
		const colours = [ ... charts.extraColours ];

		for (const extra of config.extra) {
			const colour = colours.shift();

			const yAxis = extra.multiplier === 1 ?
				chart.yAxis :
				(
					isFinancialsSection ?
					chart.addYAxisWithPrefixes(chart.panel, {
						renderer: {
							opposite: true,
						},

						syncWithAxis: chart.yAxis,
						numberFormat: "#.#a",
					},
					{
						bigNumberPrefixes: charts.bigNumberPrefixes,
						smallNumberPrefixes: [],
					}) :
					chart.addYAxis(chart.panel, {
						renderer: {
							opposite: true,
						},

						syncWithAxis: chart.yAxis,
						numberFormat: "#.#a",
					})
				);

			chart.addSeries(
				chart[ `${extra.series_type ?? 'line'}Series` ](
					{
						stroke: colour,
						fill: extra.series_type === 'column' ?colour : null,
						legendLabelText: extra.title,
						valueYField: extra.dataKey,
					},
					yAxis
				)
			);
		}
	}

	if (config.medianValue) {
		chart.addGuide(config.medianValue, chart.yAxis, {
			strokeDasharray: charts.values.strokeDash,
			// TODO: add tooltip here
			// balloonText: `The historical median value is <strong>${config.medianValue}</strong>.`,
		});
	}

	return chart;
};
